import BaseApiClient from '../BaseApiClient';
import { SHARED_MAILBOX_PAGE_SIZE, sharedMailboxApiPaths } from './paths';
import type {
  SharedMailbox,
  SharedMailboxConnectionTest,
  SharedMailboxPayload
} from './types';

export type {
  SharedMailbox,
  SharedMailboxAssignmentMode,
  SharedMailboxConnectionTest,
  SharedMailboxOption,
  SharedMailboxPayload,
  SharedMailboxStatus,
  SharedMailboxUser
} from './types';

export { sharedMailboxPayload } from './types';
export { sharedMailboxQueryKeys } from './query-keys';
export { useSharedMailboxesQuery } from './use-shared-mailbox-queries';
export {
  useCreateSharedMailboxMutation,
  useDeleteSharedMailboxMutation,
  useTestSharedMailboxConnectionMutation,
  useUpdateSharedMailboxMutation
} from './use-shared-mailbox-mutations';

export class ApiSharedMailboxes extends BaseApiClient {
  async getAll(): Promise<SharedMailbox[]> {
    const res = await this.client.get(sharedMailboxApiPaths.sharedMailboxes, {
      params: { 'page[size]': SHARED_MAILBOX_PAGE_SIZE }
    });
    return res.data.data;
  }

  async create(payload: SharedMailboxPayload): Promise<SharedMailbox> {
    const res = await this.client.post(
      sharedMailboxApiPaths.sharedMailboxes,
      payload
    );
    return res.data.data;
  }

  async update(
    id: string,
    payload: SharedMailboxPayload
  ): Promise<SharedMailbox> {
    const res = await this.client.put(
      sharedMailboxApiPaths.sharedMailbox(id),
      payload
    );
    return res.data.data;
  }

  async delete(id: string): Promise<void> {
    await this.client.delete(sharedMailboxApiPaths.sharedMailbox(id));
  }

  async testConnection(
    emailAddress: string
  ): Promise<SharedMailboxConnectionTest> {
    const res = await this.client.post(sharedMailboxApiPaths.connectionTests, {
      email_address: emailAddress
    });
    return res.data.data;
  }
}
